import * as React from "react"
import Layout from "../components/layout"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Grid from "@material-ui/core/Grid"
import Text from "../components/typography/text"
import Box from "@material-ui/core/Box"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import Button from "@material-ui/core/Button"
import ContactUs from "./contactUs"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { useTheme } from "@material-ui/core"
import Container from "@material-ui/core/Container"
import image from "../images/dfsHome.png"
const IndexPage = () => {
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))
  const mdDown = useMediaQuery(theme.breakpoints.down("md"))
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <Grid style={{  backgroundColor:"white"}}>
      <Container maxWidth="lg">
        <Grid container direction="row">
          <Grid
            item
            xs={11}
            lg={4}
            xl={4}
            style={{ paddingTop: smDown ? "100px" : "280px" }}
          >
            {" "}
            <div>
              <Text variant={"h2"} style={{ fontWeight: "bold" }}>
                Doctors for Syria
              </Text>
              <Text
                variant={"body2"}
                style={{
                  paddingTop: "25px",
                }}
              >
                was founded by a group of Syrians natives and expatriates on the
                idea of providing health care related second opinion web based
                services to Syrians physicians and patients and web based
                medical educational material and information.
              </Text>
            </div>
            <Grid container>
              {smDown && <Grid item xs={10}></Grid>}
              {mdDown && (
                <>
                <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                  <StaticImage
                    src="../images/phonee.png"
                    quality={95}
                    width={350}
                    formats={["auto", "webp", "avif"]}
                    alt="mission"
                  />
             </Grid>
                    <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                  <hr style={{ color: "#707070", height: "3px" }}></hr>
               
                </Grid>
                </>
              )}
            </Grid>
            <div>
              <Text
                variant={"body2"}
                style={{
                  color: "#707070",
                  paddingTop: smDown ? "0px" : "200px",
                }}
              >
              
              </Text>
              <Text variant={"h2"} style={{ fontWeight: "bold" }}>
                Nonprofit Health <br></br> Care Initiative
              </Text>
              <Text
                variant={"body2"}
                style={{
                  paddingTop: "25px",
                }}
              >
                DFS consist of a group of experienced and licensed physicians
                representing different schools of medicine tending from North
                America to Europe and the Middle East. They will serve to
                provide medical second options to Syrian patients and to Syrian
                doctors who desire consultation from a colleague. Our physicians
                are compassionate and committed to providing their service with
                individual and personal attention.
              </Text>
              <br></br>
              <Link to={"/mission"}>
                <div
                  style={{
                    display: mdDown ? "flex" : "inherit",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      borderRadius: "80px",
                      backgroundColor: "#3978E4",
                      height: "40px",
                      padding: "25px",
                      textTransform: "none",
                    }}
                  >
                    {" "}
                    <Text
                      variant={"subtitle1 "}
                      bold
                      style={{
                        color: "white",
                        fontSize: "15px",
                      }}
                    >
                      Learn more
                    </Text>
                  </Button>
                </div>
              </Link>
              {mdDown && (
                <Grid item xs={12}>
                  <StaticImage
                    src="../images/Untitled-1sss.png"
                    quality={95}
                    width={350}
                    formats={["auto", "webp", "avif"]}
                    alt="mission"
                    style={{}}
                  />
                  <hr style={{ color: "#707070", height: "3px" }}></hr>
                </Grid>
              )}
            </div>
            <div>
              {" "}
              <Text
                variant={"body2"}
                style={{
                  color: "#707070",
                  paddingTop: smDown ? "0px" : "160px",
                }}
              >
         
              </Text>
              <Text variant={"h2"} style={{ fontWeight: "bold" }}>
                Your well-being <br></br>is our top priority
              </Text>
              <Text
                variant={"body2"}
                style={{
                  paddingTop: "25px",
                }}
              >
                The cases will be reviewed by our physicians (including but not
                restricted to history and physical exam, laboratory and imaging
                studies) and through proper communication, a feedback will be
                provided.
              </Text>
              {mdDown && (
                <Grid item xs={12}>
                  <StaticImage
                    src="../images/Untitled-4.png"
                    quality={95}
                    width={350}
                    formats={["auto", "webp", "avif"]}
                    alt="mission"
                  />
                </Grid>
              )}
            </div>
          </Grid>
          {mdDown ? null : (
            <Grid
              item
              lg={8}
              xl={8}
              textAlign="end"
              style={{ paddingLeft: "300px" }}
            >
              <img src={image} width={550}></img>
            </Grid>
          )}
        </Grid>
      </Container>

      <Grid
        container
        justifyContent="center"
        // alignItems="center"

        style={{
          backgroundColor: "#EEF4F9",
          height: smDown ? "1700px" : "unset",
        }}
      >
        <Grid
          item
          xs={11}
          sm={11}
          md={11}
          lg={12}
          style={{ textAlign: smDown ? "unset" : "center" }}
        >
          <Text
            variant={"h2"}
            bold
            style={{ paddingTop: "90px", fontWeight: "bold" }}
          >
            How it Works?
          </Text>
          {mdDown?(   <Text
            variant={"body2"}
            style={{
              paddingTop: smDown ? "25px" : "25px",
            }}
          >
            Devoted to complement and strengthen the health care provided to the
            Syrian citizens DFS consists of a group of experienced and licensed
            physicians representing different schools of medicine extending from
            North America to Europe and the Middle East, They will serve to
            provide medical second opinions to Syrian patients and to Syrian
            doctors who desire a consultation from a colleague.
          </Text>):(   <Text
            variant={"body2"}
            style={{
              paddingTop: smDown ? "25px" : "25px",
            }}
          >
            Devoted to complement and strengthen the health care provided<br></br> to the
            Syrian citizens DFS consists of a group of experienced and<br></br> licensed
            physicians representing different schools of medicine<br></br> extending from
            North America to Europe and the Middle East,<br></br> They will serve to
            provide medical second opinions<br></br> to Syrian patients and to Syrian
            doctors who desire<br></br> a consultation from a colleague.
          </Text>)}
       
       
        </Grid>
        <Container maxWidth="lg">
          <Grid container direction="row" justifyContent="center">
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <Card
                style={{
                  maxWidth: "105px",
                  borderRadius: 100,
                  height: 108,
                  boxShadow: "5px 5px 26px rgba(57 , 120, 228 , 0.13)",
                  position: "relative",
                  top: 68,
                  left: 30,
                }}
              >
                <CardContent style={{ textAlign: "center" }}>
                  <Text variant={"h1"} bold>
                    1
                  </Text>
                </CardContent>
              </Card>
              <Card
                style={{
                  maxWidth: "350px",
                  borderRadius: "50px",
                  height: "320px",
                  boxShadow: "5px 5px 26px rgba(57 , 120, 228 , 0.13)",
                  marginBottom: 28,
                }}
              >
                <CardContent>
                  <Text
                    variant={"h4"}
                    style={{ marginTop: 90, fontWeight: "bold" }}
                  >
                    Sign-Up
                  </Text>
                  <br></br>
                  <Text variant={"body2"}>
                    Our model tries to overcome the distance obstacle and the
                    lack of direct Physician contact and exam by restoring to
                    modern communication technologies,internsifying information
                    reporting and relying on.
                  </Text>
                </CardContent>
              </Card>
            </Grid>
            <Grid
              item
              lg={4}
              md={4}
              sm={12}
              xs={12}
              style={{
                position: "relative",
                bottom: smDown ? "20px" : "0",
               
              }}
            >
              <Card
                style={{
                  maxWidth: "105px",
                  borderRadius: 100,
                  height: 108,
                  boxShadow: "5px 5px 26px rgba(57 , 120, 228 , 0.13)",
                  position: "relative",
                  top: 68,
                  left: 30,
                }}
              >
                <CardContent style={{ textAlign: "center" }}>
                  <Text variant={"h1"} bold>
                    2
                  </Text>
                </CardContent>
              </Card>
              <Card
                style={{
                  maxWidth: "350px",
                  borderRadius: "50px",
                  height: "320px",
                  boxShadow: "5px 5px 26px rgba(57 , 120, 228 , 0.13)",
                  marginBottom: 28,
                }}
              >
                <CardContent>
                  <Text
                    variant={"h4"}
                    style={{ marginTop: 90, fontWeight: "bold" }}
                  >
                    Create a Case
                  </Text>
                  <br></br>
                  <Text variant={"body2"}>
                    Our service is delivered via web communicatation channels
                    (Email, voice over IP service, etc.) or any other channel
                    agreed upon between the parties involved.
                  </Text>
                </CardContent>
              </Card>
            </Grid>

            <Grid
              item
              lg={4}
              md={4}
              sm={12}
              xs={12}
              style={{ position: "relative", bottom: smDown ? "40px" : "0" }}
            >
              <Card
                style={{
                  maxWidth: "105px",
                  borderRadius: 100,
                  height: 108,
                  boxShadow: "5px 5px 26px rgba(57 , 120, 228 , 0.13)",
                  position: "relative",
                  top: 68,
                  left: 30,
                }}
              >
                <CardContent style={{ textAlign: "center" }}>
                  <Text variant={"h1"} bold>
                    3
                  </Text>
                </CardContent>
              </Card>
              <Card
                style={{
                  maxWidth: "350px",
                  borderRadius: "50px",
                  height: "320px",
                  boxShadow: "5px 5px 26px rgba(57 , 120, 228 , 0.13)",
                  marginBottom: 28,
                }}
              >
                <CardContent>
                  <Text
                    variant={"h4"}
                    style={{ marginTop: 90, fontWeight: "bold" }}
                  >
                    Get Feedback
                  </Text>
                  <br></br>
                  <Text variant={"body2"}>
                    Our service is delivered via web communicatation channels
                    (Email, voice over IP service, etc.) or any other channel
                    agreed upon between the parties involved.
                  </Text>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <ContactUs />
    </Grid>
  )
}
export default IndexPage
